/**
 * Контент справки для страницы RegTech (SENT / e-TOLL).
 * Используется в панели справки HelpPanel.
 */
export default {
  // Идентификатор страницы
  pageKey: 'regtech',

  // Ключ локализации заголовка страницы
  titleKey: 'help.pages.regtech.title',

  // Ключ локализации описания страницы
  overviewKey: 'help.pages.regtech.overview',

  // Идентификатор связанного тура
  tourId: 'regtech-page',

  // FAQ - часто задаваемые вопросы
  faq: [
    {
      id: 'what-is-sent',
      questionKey: 'help.pages.regtech.faq.whatIsSent.question',
      answerKey: 'help.pages.regtech.faq.whatIsSent.answer',
    },
    {
      id: 'what-is-etoll',
      questionKey: 'help.pages.regtech.faq.whatIsEtoll.question',
      answerKey: 'help.pages.regtech.faq.whatIsEtoll.answer',
    },
    {
      id: 'enable-service',
      questionKey: 'help.pages.regtech.faq.enableService.question',
      answerKey: 'help.pages.regtech.faq.enableService.answer',
    },
    {
      id: 'view-logs',
      questionKey: 'help.pages.regtech.faq.viewLogs.question',
      answerKey: 'help.pages.regtech.faq.viewLogs.answer',
    },
    {
      id: 'what-is-rmpd',
      questionKey: 'help.pages.regtech.faq.whatIsRmpd.question',
      answerKey: 'help.pages.regtech.faq.whatIsRmpd.answer',
    },
    {
      id: 'transmission-status',
      questionKey: 'help.pages.regtech.faq.transmissionStatus.question',
      answerKey: 'help.pages.regtech.faq.transmissionStatus.answer',
    },
    {
      id: 'troubleshoot-errors',
      questionKey: 'help.pages.regtech.faq.troubleshootErrors.question',
      answerKey: 'help.pages.regtech.faq.troubleshootErrors.answer',
    },
    {
      id: 'register-device',
      questionKey: 'help.pages.regtech.faq.registerDevice.question',
      answerKey: 'help.pages.regtech.faq.registerDevice.answer',
    },
  ],

  // Контекстные подсказки для элементов страницы
  tooltips: {
    serviceToggle: 'help.tooltips.regtech.serviceToggle',
    logs: 'help.tooltips.regtech.logs',
    rmpd: 'help.tooltips.regtech.rmpd',
    statusFilter: 'help.tooltips.regtech.statusFilter',
  },

  // Связанные туры (для раздела "Другие обзоры")
  relatedTours: ['onboarding', 'devices-page'],
}
